import Designer from "emun.on-demand/lib/designer";

export default $parse => ({
  restrict: "C",
  scope: false,
  link(scope, element, attrs) {
    let name = attrs.ngModel || attrs.designer;
    if (name) {
      var designer = new Designer(scope, element, attrs);
      $parse(name).assign(scope, designer);
      scope.$on("$destroy", () => designer.destroy());
    }
  }
});
